import { Link } from "react-router-dom";

const hashSlide = (src) => {
  let h = 5381;
  for (let i = 0; i < src.length; i++) h = ((h * 33) ^ src.charCodeAt(i)) >>> 0;
  return h % 2 === 0 ? "8px" : "-8px";
};

/* Editorial card — image top, eyebrow, serif title, factual line.
   Hover triad (managed in index.css):
     • .card-img          → 1.02 scale, 1200ms
     • .card-title        → 4px translate, 900ms
     • .card-eyebrow      → letter-spacing 0.28em → 0.22em (tighten)
     • .card-underline    → gold 1px, scaleX(0) → scaleX(1) left→right
   Card lift + soft navy shadow now added on `.editorial-card:hover`.
   The image lives inside `.parallax-inner > .reveal-scale` so scroll
   parallax + entry animation + hover scale apply without touching the
   continuous Ken Burns transform on the <img> itself. */
export const EditorialCard = ({ to, imageSrc, imageAlt, eyebrow, title, line, testId }) => {
  return (
    <Link
      to={to}
      data-testid={testId}
      className="editorial-card group block bg-cream border-t border-b border-rule md:border md:border-rule reveal mask-reveal"
    >
      <div className="relative w-full overflow-hidden aspect-[4/3]">
        <div className="absolute inset-0 parallax-inner">
          <span
            className="reveal-scale"
            style={{ "--rv-x": hashSlide(imageSrc) }}
          >
            <img
              src={imageSrc}
              alt={imageAlt}
              loading="lazy"
              className="card-img absolute inset-0 h-full w-full object-cover"
            />
          </span>
        </div>
      </div>
      <div className="px-8 md:px-10 py-9 md:py-11">
        <div
          className="card-eyebrow font-sans text-[10.5px] font-medium uppercase text-mute"
          style={{ letterSpacing: "0.28em" }}
        >
          {eyebrow}
        </div>
        <h3 className="mt-5 font-serif font-normal text-navy text-[22px] md:text-[26px] leading-[1.15]">
          <span className="card-title card-underline">
            {title}
          </span>
        </h3>
        <p className="mt-5 font-sans text-[14.5px] font-normal leading-relaxed text-navy max-w-md">
          {line}
        </p>
      </div>
    </Link>
  );
};

export default EditorialCard;
